var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading flex ai-c jc-c fd-c"},[_vm._m(0),_c('div',{staticClass:"loading-content flex text-center mt-6"},[_c('p',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('br'),_c('small',[_vm._v(" "+_vm._s(_vm.description)+" ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-content flex fgap1"},[_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }